export default __webpack_public_path__ + "static/media/trash.05ae366f.svg";